<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-desktop"></i>
        {{ $t('CHANNEL_SETTINGS_DEVICE_SETTINGS_TITLE') }}
      </h5>
    </div>
    <div class="card-body">
      <transition-group name="fade">
        <div class="row mt-2" v-for="(device, index) in settings.devices" :key="'device' + index">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header bg-sidebar text-white">
                <div class="row">
                  <div class="col">
                    {{ $t('CHANNEL_SETTINGS_DEVICE', {index: index + 1}) }}
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">

                  <div class="col-12 col-md-6">
                    <label :for="'deviceType' + index" class="bold">{{ $t('CHANNEL_SETTINGS_DEVICE_LABEL_TYPE')
                      }}</label>
                    <select class="form-control" :id="'deviceType' + index" v-model="device.type">
                      <option value="streamer">{{ $t('CHANNEL_SETTINGS_DEVICE_TYPE_STREAMER') }}</option>
                      <option value="camera">{{ $t('CHANNEL_SETTINGS_DEVICE_TYPE_CAMERA') }}</option>
                      <option value="encoder">{{ $t('CHANNEL_SETTINGS_DEVICE_TYPE_ENCODER') }}</option>
                    </select>
                  </div>

                  <div class="col-12 col-md-6">
                    <label :for="'deviceName' + index" class="bold">{{ $t('CHANNEL_SETTINGS_DEVICE_LABEL_NAME') }}</label>
                    <input type="text" v-model="device.name" :placeholder="$t('CHANNEL_SETTINGS_DEVICE_LABEL_NAME')" class="form-control"
                           :id="'deviceName' + index">
                  </div>

                  <div class="col-12 mb-1">
                    <label :for="'deviceUri' + index" class="bold">{{ $t('CHANNEL_SETTINGS_DEVICE_LABEL_URI') }}</label>
                    <input type="text" v-model="device.uri" :placeholder="$t('CHANNEL_SETTINGS_DEVICE_LABEL_URI')" class="form-control"
                           :id="'deviceUri' + index">
                  </div>

                </div>

                <div class="row mt-2 text-right">
                  <div class="col">
                    <button class="btn text-danger" @click="removeDeviceByIndex(index)">
                      <i class="fa fa-times"></i> {{ $t('CHANNEL_SETTINGS_REMOVE_DEVICE') }}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </transition-group>

      <div class="row mt-2">
        <div class="col">
          <div class="card">
            <div class="card-body p-0">
              <button class="btn" @click="addEmptyDevice">
                <i class="fa fa-plus"></i>
                {{ $t('CHANNEL_SETTINGS_ADD_DEVICE') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSettings',
  methods: {
	    addEmptyDevice() {
		    this.settings.devices.push({
			    name: '',
        uri: '',
        type: '',
		    });
	    },

	    /**
	     * Removes the given Stream
	     */
	    removeDeviceByIndex(index) {
		    this.settings.devices = this.settings.devices.filter((device, deviceIndex) => deviceIndex !== index);
	    },
  },
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>
